import YFormAmount from './Amount';

export { YFormAmount };
export default YFormAmount;
